import { render } from "./MenusItemsTable.vue?vue&type=template&id=5b6cb759"
import script from "./MenusItemsTable.vue?vue&type=script&lang=js"
export * from "./MenusItemsTable.vue?vue&type=script&lang=js"

import "./MenusItemsTable.vue?vue&type=style&index=0&id=5b6cb759&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__